import { useState } from "react";

const SwitchCheckbox = ({label, name, checked}) => {
    const [tmpChecked, setTmpChecked] = useState(checked);

    return (
        <div className="custom-control custom-checkbox my-2" key={`form_${name}`}>
            <input
                type="checkbox"
                className="custom-control-input"
                id={name}
                name={name}
                checked={tmpChecked}
                key={name}
                onChange={(e) => {
                    setTmpChecked(e.target.checked);
                    // onChange && onChange(e.target.checked);
                }}
            />
            <label className="custom-control-label" htmlFor={name}>
                {label}
            </label>
        </div>
    );
}

export default SwitchCheckbox